// auto-generated by Typewriter template _enums.tst from PortCall.Models\VesselResult\ExternalVesselSearchType.cs
export enum ExternalVesselSearchType { 
    CallSign = 20,
    IMO = 0,
    MMSI = 10
}

export const ExternalVesselSearchTypeDisplayName : { [val : number] : string } = { 
    20: 'CallSign',
    0: 'IMO',
    10: 'MMSI'
}

export const ExternalVesselSearchTypes : { Id : ExternalVesselSearchType, Name : string }[] = [ 
    { Id: ExternalVesselSearchType.CallSign, Name: 'CallSign' },
    { Id: ExternalVesselSearchType.IMO, Name: 'IMO' },
    { Id: ExternalVesselSearchType.MMSI, Name: 'MMSI' }
]



// WEBPACK FOOTER //
// ./server/enums/ExternalVesselSearchType.ts